export default __webpack_public_path__ + "static/novaya-white-en-38ff913644a0147139302edcf39c90c1.svg";